export default __webpack_public_path__ + "static/pp-ecobonus-mobile-408b70d0e3b4e5cd9dface239467e1f2.jpg";